import { BranchData } from 'entities/Branches/interfaces';
import { UserBranches } from 'entities/AADGroup/interfaces';
import { Branche, Role } from 'entities/Roles';
import { Actions } from './actions';
import {
  GET_BRANCHES_ERROR,
  GET_BRANCHES_REQUEST,
  GET_BRANCHES_SUCCESS,
  GET_ROLES_ERROR,
  GET_ROLES_REQUEST,
  GET_ROLES_SUCCESS,
  SET_BRANCH_TITLE,
  GET_USER_BRANCHES_REQUEST,
  GET_USER_BRANCHES_SUCCESS,
  GET_USER_BRANCHES_FAILURE,
} from './constants';

export const initialState = {
  loading: false as boolean,
  allBranchesError: null as null | Error,
  allRolesError: null as null | Error,
  allUserBranchesError: null as null | Error,

  roles: null as null | Role[],
  branchTitle: JSON.parse(localStorage.getItem('branchId') || 'null') as Branche,
  branches: null as null | BranchData[],
  aadGroups: null as null | UserBranches[],
};

export type LogoutState = typeof initialState;

export const logoutReducer = (state: LogoutState = initialState, action: Actions): LogoutState => {
  switch (action.type) {
    case GET_ROLES_REQUEST: {
      return {
        ...state,
        loading: true,
        roles: [],
        allRolesError: null,
      };
    }
    case GET_ROLES_SUCCESS: {
      return {
        ...state,
        loading: false,
        roles: action.payload.roles,
        allRolesError: null,
      };
    }
    case GET_ROLES_ERROR: {
      return {
        ...state,
        loading: false,
        roles: [],
        allRolesError: action.payload,
      };
    }
    case SET_BRANCH_TITLE: {
      return {
        ...state,
        loading: false,
        allBranchesError: null,
        allRolesError: null,
        branchTitle: action.payload,
      };
    }
    case GET_BRANCHES_REQUEST: {
      return {
        ...state,
        loading: true,
        allBranchesError: null,
      };
    }
    case GET_BRANCHES_SUCCESS: {
      return {
        ...state,
        loading: false,
        branches: action.payload,
        allBranchesError: null,
      };
    }
    case GET_BRANCHES_ERROR: {
      return {
        ...state,
        loading: false,
        branches: [],
        allBranchesError: action.payload,
      };
    }
    case GET_USER_BRANCHES_REQUEST:
      return {
        ...state,
        loading: true,
        aadGroups: [],
        allUserBranchesError: null,
      };
    case GET_USER_BRANCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        aadGroups: action.payload.body,
        allUserBranchesError: null,
      };
    case GET_USER_BRANCHES_FAILURE:
      return {
        ...state,
        loading: false,
        aadGroups: [],
        allUserBranchesError: action.payload,
      };
    default: {
      return state;
    }
  }
};
